import { Helmet } from "react-helmet-async";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <div id="error-page">
      <Helmet>
        <title>AS Maskiner - Oväntat fel</title>
      </Helmet>

      <h1>Oops!</h1>
      <p>Sorry, nu fick vi ett oväntat fel.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
